import { render, staticRenderFns } from "./DivisionMenu.vue?vue&type=template&id=3918dc60&"
import script from "./DivisionMenu.vue?vue&type=script&lang=ts&"
export * from "./DivisionMenu.vue?vue&type=script&lang=ts&"
import style0 from "./DivisionMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VIcon,VSelect})
